import { oc } from "@orpc/contract";
import {
  GetColumnConfigInputSchema,
  GetColumnConfigResponseSchema,
  UpsertColumnConfigInputSchema,
  UpsertColumnConfigResponseSchema,
} from "./user-table-column-configs.contract";

export const orgTableColumnConfigsContracts = {
  get: oc
    .input(GetColumnConfigInputSchema)
    .output(GetColumnConfigResponseSchema)
    .route({
      method: "GET",
      summary: "Get organization default table columns",
      description:
        "Returns the organization-wide default column layout (and sort, when saved) for one table, or null when none is set.",
    }),
  upsert: oc
    .input(UpsertColumnConfigInputSchema)
    .output(UpsertColumnConfigResponseSchema)
    .route({
      method: "POST",
      summary: "Set organization default table columns",
      description:
        "Saves the default column layout (and sort, when sent) everyone in the organization sees for one table. Requires Gently staff administrator access or Update permission on OrganizationConfig.",
    }),
} as const;
